import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { CheckCircle, ArrowRight } from 'lucide-react'
import { toast } from 'react-hot-toast'

const PaymentSuccess: React.FC = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const sessionId = searchParams.get('session_id')

  useEffect(() => {
    if (sessionId) {
      // Optionally verify the payment session with the backend
      toast.success('Płatność została pomyślnie zrealizowana!')
    }
  }, [sessionId])

  return (
    <div className="min-h-screen bg-dark-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        <div className="bg-dark-800 rounded-lg p-8 border border-dark-700">
          <div className="flex justify-center mb-6">
            <CheckCircle className="h-16 w-16 text-green-500" />
          </div>
          
          <h1 className="text-2xl font-bold text-white mb-4">
            Płatność zakończona pomyślnie!
          </h1>
          
          <p className="text-gray-400 mb-6">
            Dziękujemy za zakup! Twoja licencja została aktywowana i możesz już z niej korzystać.
            Szczegóły zostały wysłane na Twój adres email.
          </p>

          <div className="space-y-3">
            <button
              onClick={() => navigate('/licenses')}
              className="w-full bg-primary text-white py-3 rounded-lg hover:bg-primary/90 transition-colors flex items-center justify-center"
            >
              Przejdź do moich licencji
              <ArrowRight className="ml-2 h-4 w-4" />
            </button>
            
            <button
              onClick={() => navigate('/dashboard')}
              className="w-full bg-dark-700 text-gray-300 py-3 rounded-lg hover:bg-dark-600 transition-colors"
            >
              Wróć do Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PaymentSuccess